import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/node_modules/.pnpm/next-intl@4.3.4_next@15.3.8_@babel+core@7.26.10_babel-plugin-macros@3.1.0_react-dom@19._94b145417c960af4f04fece1f2e71694/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/src/src/components/Image/index.tsx");
